import "./styles.scss";

import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import clsx from "clsx";

import { useHamburger } from "context/hamburger";

import { getColorVariant } from "utils";

import { clinicsData } from "data/clinics";

const ContactPopup = () => {
  const { isContactOpen, setIsContactOpen } = useHamburger();

  useEffect(() => {
    const handleResize = () => {
      const ww = window.innerWidth;

      if (ww < 992) {
        setIsContactOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [setIsContactOpen]);

  useEffect(() => {
    if (isContactOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => (document.body.style.overflow = "");
  }, [isContactOpen]);

  return (
    <AnimatePresence initial={false}>
      {isContactOpen && (
        <motion.div
          className="contact-popup"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ type: "tween", duration: 0.3 }}
        >
          <motion.div className="contact-popup__dialog">
            <div className="contact-popup__content">
              {clinicsData.map((clinic, index) => {
                const variant = getColorVariant(index + 1);

                return (
                  <div
                    className={clsx(
                      "contact-popup__clinic",
                      variant && `contact-popup__clinic--${variant}`
                    )}
                    key={index}
                  >
                    <div
                      className="contact-popup__clinic-image"
                      style={{ backgroundImage: `url(${clinic.image})` }}
                    />
                    <p>{clinic.name}</p>
                    <ul>
                      {clinic.contact.phones.map((phone, index) => (
                        <li key={index}>
                          <a href={`tel:+48${phone.replaceAll(" ", "")}`}>
                            Zadzwoń {phone}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>
          </motion.div>
          <button
            className="contact-popup__backdrop"
            onClick={() => setIsContactOpen(false)}
          >
            Zamknij
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ContactPopup;
